﻿import { getSiblings } from '..'

let departmentMenuDom
let listItems

// Closes all expanded list items
const closeExpanded = () => {
    listItems.forEach((item) => item.classList.remove('show'))
}

// Core toggle logic for opening/closing a parent <li>
const toggleOpenState = (li) => {
    if (!li) return

    const isOpen = li.classList.contains('show')
    li.classList.toggle('show')

    if (!isOpen) {
        const siblings = getSiblings(li)
        siblings?.forEach((sibling) => sibling.classList.remove('show'))
    }
}

// Button click — typical for nested menus
const buttonClickHandler = (e) => {
    const parentLi = e.target.closest('li')
    toggleOpenState(parentLi)
    e.stopPropagation()
}

// Click handler for <a> tags inside top-level .has-kids
const linkClickHandler = (e) => {
    const parentLi = e.target.closest('li.has-kids')
    if (!parentLi) return

    // Only toggle if this is a menu item with children (not a direct link to another page)
    toggleOpenState(parentLi)

    // Prevent navigation if we're using this link to toggle the menu
    e.preventDefault()
    e.stopPropagation()
}

// Listen for outside clicks to close expanded menus
const addEventListenerToDocumentClicks = () => {
    document.addEventListener('click', (e) => {
        if (!departmentMenuDom.contains(e.target)) {
            closeExpanded()
        }
    })
}

// Entry point for initializing the menu
export const addDepartmentMainMenuFunctionality = (ui) => {
    if (!ui) return

    departmentMenuDom = ui
    listItems = departmentMenuDom.querySelectorAll('li')

    addEventListenerToDocumentClicks()

    // Add handler to any button that toggles child menus
    departmentMenuDom.querySelectorAll('ul .has-kids > button').forEach((btn) => {
        btn.addEventListener('click', buttonClickHandler)
    })

    // Add handler to top-level links if no button exists
    departmentMenuDom.querySelectorAll('ul .has-kids > a.top-lvl').forEach((link) => {
        link.addEventListener('click', linkClickHandler)
    })
}
